/**
 * Canonical print/PDF document CSS.
 * Single source of truth for styling when generating PDF (Email and download) so output matches Print.
 * Inline this into HTML before PDF generation so styles are reliable (no external asset loading).
 */
export const PRINT_DOCUMENT_CSS = `
/* Page setup - white background, content fills page */
@page { size: letter; margin: 0.5in; }
html, body { margin: 0; padding: 0; background: white !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
body { font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.6; color: #2d3748; }
.print-view { width: 100%; max-width: 100%; margin: 0; padding: 0 0.5in; background: white; box-sizing: border-box; }
.print-template-content { font-family: inherit; }

/* Header / document type */
.print-header { text-align: center; margin-bottom: 2rem; border-bottom: 2px solid #2d3748; padding-bottom: 1rem; }
.print-header h1 { font-size: 2rem; color: #2d3748; margin: 0; }
.print-header p { color: #718096; margin: 0.5rem 0 0 0; }
.print-document-type { text-align: center; margin: 2rem 0; }
.print-document-type h2 { font-size: 1.5rem; color: #2d3748; margin: 0; }

/* Info sections */
.print-info-section { display: flex; justify-content: space-between; margin-bottom: 2rem; }
.print-client-info h3 { font-size: 1rem; color: #2d3748; margin-bottom: 0.5rem; }
.print-client-info p { margin: 0.25rem 0; color: #4a5568; }
.print-document-info p { margin: 0.5rem 0; color: #4a5568; text-align: right; }

/* Items table - fit on single page, compact when many rows or sections */
.print-items-table { width: 100%; border-collapse: collapse; margin-bottom: 1.25rem; page-break-inside: avoid; }
.print-items-table th { background-color: #f7fafc; padding: 0.75rem; text-align: left; border-bottom: 2px solid #e2e8f0; font-weight: 600; color: #2d3748; }
.print-items-table td { padding: 0.75rem; border-bottom: 1px solid #e2e8f0; color: #4a5568; }
.print-items-table .money-col, .print-items-table .money-cell { white-space: nowrap; min-width: 5.5em; overflow: visible; }
.print-items-table .item-separator-row td { padding: 0.5rem 0; border: none; }
.print-items-table .item-separator .separator-line { border-top: 1px solid #e2e8f0; margin: 0; }
.print-items-table .item-section-subtotal-row td,
.print-items-table .item-section-tax-row td { padding: 0.5rem 0.75rem; border-bottom: 1px solid #e2e8f0; background: #f7fafc; font-weight: 500; }
.print-items-table .item-section-subtotal-row .section-subtotal-label,
.print-items-table .item-section-tax-row .section-subtotal-label { text-align: right; }
/* Compact table - fits more on single page (applied when rows/sections could overflow) */
.print-items-table.print-items-table--compact th, .print-items-table.print-items-table--compact td { padding: 0.35rem 0.5rem; font-size: 10pt; }
.print-items-table.print-items-table--compact .item-separator-row td { padding: 0.2rem 0; }
.print-items-table.print-items-table--compact .item-section-subtotal-row td,
.print-items-table.print-items-table--compact .item-section-tax-row td { padding: 0.3rem 0.5rem; }
.print-items-table.print-items-table--xcompact th, .print-items-table.print-items-table--xcompact td { padding: 0.2rem 0.35rem; font-size: 9pt; }
.print-items-table.print-items-table--xcompact .item-separator-row td { padding: 0.12rem 0; }
.print-items-table.print-items-table--xcompact .item-section-subtotal-row td,
.print-items-table.print-items-table--xcompact .item-section-tax-row td { padding: 0.2rem 0.35rem; }

/* Totals */
.print-totals { margin-top: 2rem; padding-top: 1rem; border-top: 2px solid #e2e8f0; text-align: right; }
.print-totals-row { display: flex; justify-content: flex-end; gap: 1rem; margin-bottom: 0.5rem; padding: 0.5rem 0; }
.print-totals-row span:first-child { min-width: 8em; text-align: right; }
.print-totals-row.print-total { font-size: 1.25rem; font-weight: 600; border-top: 2px solid #e2e8f0; padding-top: 1rem; margin-top: 1rem; }

/* Notes */
.print-notes { margin-top: 2rem; padding-top: 1rem; border-top: 1px solid #e2e8f0; }
.print-notes h3, .print-notes p strong { font-size: 1rem; color: #2d3748; margin-bottom: 0.5rem; }
.print-notes p { color: #4a5568; line-height: 1.6; white-space: pre-wrap; margin: 0 0 0.5rem 0; }

/* Paragraphs in body */
.print-template-content p { margin: 0 0 12px 0; }
.page-break { page-break-after: always; }
.page-break-before { page-break-before: always; }
`;
